import type {ReactElement} from 'react';
import {FontControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-control/font-control';
import type {SubmitButtonFontControlProps} from './submit-button-font-control.types';

export function SubmitButtonFontControl({component}: SubmitButtonFontControlProps): ReactElement {
  return <FontControl component={component} />;
}
